import { Card } from "@components/shadcn-ui/card";
import { applicationService } from "features/createApplication/service/applicationService";
import { ApplicationList } from "features/applications/ApplicationList";
import { MobileApplicationCard } from "features/applications/MobileApplicationCard";
import { useEffect, useState } from "react";
import { ApplicationTools } from "features/applications/ApplicationHeader";
import TableShimmer, {
  CardShimmer,
} from "features/applications/ApplicationShimmer";
import { APPLICATION_STATUS } from "features/applications/config";

export const ApplicationsPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [applicationList, setApplicationList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleStatusChange = (status: string | null) => {
    setSelectedStatus(status);
  };

  useEffect(() => {
    const fetchApplicationList = async () => {
      try {
        const respose = await applicationService.getAllSummaries();
        setApplicationList(respose);
      } catch (err) {
        console.error("Failed to fetch application by ID:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchApplicationList();
  }, []); // Add dependencies if the application ID changes

  const filteredApplications = applicationList.filter((app: any) => {
    const matchesSearch =
      app.customerName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      app.status?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      app.id?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesStatus = selectedStatus ? app.state === selectedStatus : true;

    return matchesSearch && matchesStatus;
  });

  return (
    <>
      <div className="mb-4">
        <h1 className="text-2xl font-bold">All Applications</h1>
        <p className="text-sm text-gray-500">
          View and manage all your applications in one place.
        </p>
      </div>
      <div className="mb-4">
        <ApplicationTools
          applications={filteredApplications}
          searchQuery={searchQuery}
          handleSearchChange={handleSearchChange}
          selectedStatus={selectedStatus}
          handleStatusChange={handleStatusChange}
          statuses={Object.keys(APPLICATION_STATUS)}
        />
      </div>
      <div className="hidden md:block">
        <div className="p-0 overflow-hidden">
          {isLoading ? (
            <TableShimmer />
          ) : filteredApplications.length > 0 ? (
            <ApplicationList applications={filteredApplications} />
          ) : (
            <p className="text-center bg-transparent">No applications found.</p>
          )}
        </div>
      </div>
      <div className="md:hidden">
        {isLoading ? (
          <CardShimmer />
        ) : filteredApplications.length > 0 ? (
          <div>
            <p className="text-sm text-gray-500 mb-2 p-1">
              Showing {filteredApplications.length} of {applicationList.length}{" "}
              results
            </p>
            <MobileApplicationCard applications={filteredApplications} />
          </div>
        ) : (
          <p className="text-center">No applications found.</p>
        )}
      </div>
    </>
  );
};
